import React from 'react'
import { object } from 'prop-types'
import { PrismicRichText } from '@prismicio/react'
import { generateHeadingId } from '../../util/jumpLinks'

import * as Styled from './styles/BodyContentBlock.styles'

const BodyContentBlock = ({
  data,
  bottomPaddingAdjustment,
  precomputedJumpLinks = [],
}) => {
  // Custom components that add IDs to H2 elements
  const customComponents = {
    heading2: ({ children, key }) => {
      // Helper function to extract text from React children
      const extractTextFromChildren = children => {
        if (typeof children === 'string') return children
        if (Array.isArray(children)) {
          return children
            .map(child => {
              if (typeof child === 'string') return child
              if (child && child.props && child.props.children) {
                return extractTextFromChildren(child.props.children)
              }
              return ''
            })
            .join('')
        }
        if (children && children.props && children.props.children) {
          return extractTextFromChildren(children.props.children)
        }
        return ''
      }

      const text = extractTextFromChildren(children).trim()
      const id = generateHeadingId(text)

      return (
        <h2 key={key} id={id}>
          {children}
        </h2>
      )
    },
  }

  return (
    <Styled.ContentGrid bottomPaddingAdjustment={bottomPaddingAdjustment}>
      <Styled.BodyContentBlock>
        <Styled.BodyCopy>
          <PrismicRichText
            field={data.body_copy.richText}
            components={customComponents}
          />
        </Styled.BodyCopy>
      </Styled.BodyContentBlock>
    </Styled.ContentGrid>
  )
}

BodyContentBlock.propTypes = {
  data: object,
}

export default BodyContentBlock
